let routes = [
  {
    path: "/checkout",
    name: "Checkout",
    meta: {
      requiresAuth: true,
      slug: "checkout-b2b"
    },
    component: () => import("@/views/checkout/Checkout.vue")
  },
  {
    path: "/payment",
    name: "Payment",
    meta: {
      requiresAuth: true,
      slug: "payment-b2b"
    },
    component: () => import("@/views/checkout/Payment.vue")
  },
  {
    path: "/cart/payment-error/:orderId",
    name: "PaymentError",
    meta: {
      requiresAuth: true,
      slug: "payment-error"
    },
    props: true,
    component: () => import("@/views/checkout/PaymentCompleted.vue")
  },
  {
    path: "/cart/payment-completed/:orderId",
    name: "PaymentCompleted",
    meta: {
      requiresAuth: true,
      slug: "payment-completed"
    },
    props: true,
    component: () => import("@/views/checkout/PaymentCompleted.vue")
  }
];

export default routes;
